import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Delete Item",
  itemName,
  itemType = "item",
  message,
  warningText,
  loading = false,
}) => {
  const defaultMessage = message || (
    <>
      Are you sure you want to delete{" "}
      {itemName ? <strong>{itemName}</strong> : `this ${itemType}`}?
    </>
  );

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (loading) return;
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }

        onClose();
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          pb: 2,
          pt: 2,
          px: 3,
          color: "inherit",
          position: "relative",
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            right: 0,
            width: "200px",
            height: "200px",
            background: "rgba(255, 255, 255, 0.05)",
            borderRadius: "50%",
            transform: "translate(30%, -30%)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            position: "relative",
            zIndex: 1,
          }}
        >
          <WarningAmberIcon
            sx={{
              fontSize: 28,
              color: "#d32f2f",
              filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
            }}
          />
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 3 }}>
        <DialogContentText>{defaultMessage}</DialogContentText>
        {warningText && (
          <DialogContentText sx={{ mt: 1, fontSize: "0.875rem" }}>
            {warningText}
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={loading}
          startIcon={loading && <CircularProgress size={20} color="inherit" />}
          sx={{ textTransform: "none" }}
        >
          {loading ? "Deleting..." : `Delete ${itemType}`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
